import { useState } from 'react';

/** Refresh the network-served app shell, checking installed web-app updates first. */
export function LogoRefresh({ reload = () => window.location.reload() }: { reload?: () => void }) {
  const [refreshing, setRefreshing] = useState(false);
  const refresh = async () => {
    if (refreshing) return;
    setRefreshing(true);
    try {
      const registration = await navigator.serviceWorker?.getRegistration();
      await registration?.update();
    } catch {
      // A failed worker update must not prevent the normal page refresh.
    } finally {
      reload();
      setRefreshing(false);
    }
  };

  return (
    <button
      type="button"
      className="cct-mark"
      aria-label={refreshing ? 'Refreshing system' : 'Refresh system and load latest version'}
      title="Refresh system and load latest version"
      disabled={refreshing}
      onClick={() => { void refresh(); }}
    >
      <img className="cct-mark-light" src="/brand/grid.png" alt="" width="165" height="138" />
      <img className="cct-mark-dark" src="/brand/grid-reverse.png" alt="" width="165" height="138" />
    </button>
  );
}
